import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { UserAuth } from "../../Context";
import { useFetchUserData } from "../../hooks/user/useFetchUserData";
import BrandDisplay from "../../NewsFeed/BrandDisplay";
import AddToChat3 from "../../components/AddToChat3";
import AddToList from "../../components/AddToList";
import { getBrandDetails } from "../../lib/getBrandDetails";
import useActiveBrandsStore from "../../StatesStore/ActiveBrands";
import AddToFavorites from "../ProfileShoppingList/AddToFavorites";
import FavoritesMoreUserProfile from "./FavoritesMoreUserProfile";
import { getBaseURL } from "../../lib/getBaseURL";
const FavoritesProductCard = ({ list, product, BackgroundOnSvg }) => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const { uid } = useParams();
  const { user } = UserAuth();
  const { userData } = useFetchUserData(uid);
  const [brandData, setBrandData] = useState(null);
  const navigate = useNavigate();
  const { activeBrands } = useActiveBrandsStore();
  const baseURL = getBaseURL();
  const fetchBrandData = async () => {
    try {
      // Fetch the brand's display name and logo using the getDisplayName function
      const result = await getBrandDetails(
        product?.[0]?.supplier,
        activeBrands
      );
      setBrandData(result);
      // console.log("result", result);
    } catch (error) {
      console.error("Error getting brand data:", error);
    }
  };

  useEffect(() => {
    if (!product) {
      console.log("product is missing");
      return;
    }
    if (!activeBrands) {
      console.log("activeBrands is missing");
      return;
    }
    fetchBrandData();
  }, [product, activeBrands]);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div
        className={``}
        style={{
          padding: "8px 4px",
          position: "relative",
        }}
      >
        <style jsx>
          {`
          .shopListName:hover {
            color: var(--bs-link-hover-color);
          }
          .dropdown-toggle::after {
            display: none;
          }
          .profileShoppingListModal .modal-dialog {
            max-width: 63.5rem;
          }
        `}
        </style>
        {user?.uid !== uid && (
          <div
            style={{
              position: "absolute",
              bottom: isSmallScreen ? "1.5rem" : "6.7rem",
              right: isSmallScreen ? "1.5rem" : "0.6rem",
              zIndex: 2,
              width: "24px",
              height: "24px",
              backgroundColor: "#FFFFFF",
              borderRadius: "50%",
            }}
            className="d-flex justify-content-center align-items-center"
          >
            <AddToFavorites
              list={list}
              userId={user?.uid}
              products={list.products}
              productId={list.products[0].id}
              BackgroundOnSvg={BackgroundOnSvg}
              showShareButton={true}
              type={"product"}
            />
          </div>
        )}
        {/* Images */}
        <div
          className="d-flex p-0 w-100"
          style={{
            cursor: "pointer",
            gap: "2px",
          }}
          onClick={() => {
            navigate(`/ProductDetails/${list.id}`);
          }}
        >

          {/* Main Image */}
          {product?.length === 0 ? (
            <div>
              <div
                style={{ height: "13.5rem" }}
                className="d-flex align-items-center justify-content-center w-100"
              >
                <div className="h6 px-4 text-center">
                  {uid === user?.uid ? "You" : userData?.userName} haven't added
                  any products in {list?.name}
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                position: "relative",
                height: "280px",
                width: "100%",
              }}
            >
              <Card.Img
                src={product?.[0]?.imageUrl}
                style={{
                  objectFit: "cover",
                  objectPosition: "top",
                  height: "100%",
                  borderTopLeftRadius: "6px",
                  borderTopRightRadius: "6px",
                }}
              />

            </div>
          )}
        </div>

        {/* Bottom section with text and buttons */}
        <div
          style={{
            borderRadius: "0px 0px 6px 6px",
            borderWidth: "0px 1px 1px 1px",
            borderStyle: "solid",
            borderColor: "#0000001A",
            padding: "6px 4px",
          }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div
              className="d-flex flex-column"
              style={{
                width: "80%",
                gap: "4px",
              }}
            >
              <Link
                to={`/BrandHome/${brandData?.name}`}
                style={{
                  fontFamily: "Inter",
                  fontWeight: "400",
                  fontSize: isSmallScreen ? "12px" : "14px",
                  lineHeight: "100%",
                  letterSpacing: "0%",
                  color: "#676A79",
                }}
              >
                {brandData?.displayName}
              </Link>
              <div
                className="text-truncate"
                title={product[0]?.name}
                style={{
                  fontFamily: "Inter",
                  fontWeight: "500",
                  fontSize: isSmallScreen ? "13px" : "16px",
                  letterSpacing: "0%",
                  color: "#000000",
                }}
              >
                {product[0]?.name}
              </div>
            </div>

            {/* Favorites/Share buttons */}
            {<FavoritesMoreUserProfile
              list={list}
              productId={list.products[0].id}
              userId={user?.uid}
              listLink={`${baseURL}/#/ProductDetails/${list.products[0].id}`}
              BackgroundOnSvg={BackgroundOnSvg}
              imageWidth="28px"
              svgWidth="20px"
              showShareButton={true}
              type={"Product"}
              name={product[0]?.name}
            />}
          </div>

          {/* Action buttons - now correctly positioned inside the card */}
          <div
            className="d-flex w-100"
            style={{
              gap: isSmallScreen ? "2px" : "2px",
              marginTop: "8px"
            }}
          >
            <AddToChat3 product={product[0]} componentName={"productCard"} />
            <AddToList product={product[0]} componentName={"productCard"} />
          </div>
        </div>
      </div>
    </>
  );
};

export default FavoritesProductCard;
